import { useContext } from 'react';
import { BreadcrumbItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import Breadcrumb from 'components/breadcrumb/Breadcrumb';
import useSeePropertySettingsAllowed from 'components/domain/property/useSeePropertySettingsAllowed';
import PropertySelectField from 'components/forms/domain/property/PropertySelectField';
import FormWithProvider from 'components/forms/form/Form';
import HomeIcon from 'components/icons/HomeIcon';
import { PropertyBusinessType } from 'models/Properties';
import usePropertyEditPath from 'pages/property/usePropertyEditPath';
import CalendarContext from 'pages/stackedCalendar/CalendarContext';
import { HeaderContainer } from 'pages/stackedCalendar/header/StackedCalendarHeader.styles';
import PropertyChannelsWidget from '../../../components/domain/property/channelsWidget/PropertyChannelsWidget';
import { PropertySettingsLink } from './CalendarHeader.styles';

const CalendarHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canSeePropertySettings = useSeePropertySettingsAllowed();
  const { selectedProperty, allProperties, propertiesMap } =
    useContext(CalendarContext);
  const getPropertyEditPath = usePropertyEditPath();

  if (!selectedProperty) {
    return null;
  }

  const property = propertiesMap[selectedProperty];
  const isNotUnit = property?.businessType !== PropertyBusinessType.UNIT;

  return (
    <HeaderContainer data-testid="calendar-header">
      <FormWithProvider onSubmit={() => {}} defaultValues={{}}>
        <Breadcrumb data-testid="calendar-breadcrumb">
          <BreadcrumbItem>
            <NavLink to="../calendar">{t('common.calendar')}</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <PropertySelectField
              name="property"
              properties={allProperties}
              enableHotels={false}
              value={selectedProperty}
              leftAddon={<HomeIcon />}
              onChange={(e) => {
                navigate(`?propertyUid=${e.target.value}`);
              }}
              inline
            />
          </BreadcrumbItem>
          <BreadcrumbItem active>
            {t('pageCalendar.standalone.propertyCalendar')}
          </BreadcrumbItem>
        </Breadcrumb>
      </FormWithProvider>

      {canSeePropertySettings && isNotUnit && (
        <PropertySettingsLink
          href={getPropertyEditPath(property)}
          target="_blank"
          rel="noreferrer"
        >
          <HomeIcon />
          {t('pageCalendar.standalone.propertySettings')}
        </PropertySettingsLink>
      )}

      {selectedProperty && (
        <PropertyChannelsWidget
          propertyName={property.name}
          propertyUid={selectedProperty}
        />
      )}
    </HeaderContainer>
  );
};

export default CalendarHeader;
